// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ww8++","input":"styles_input__CaHFQ","label":"styles_label__AV0Lp"};